import { render } from "./ButtonSubmit.vue?vue&type=template&id=8d25ce88&scoped=true"
import script from "./ButtonSubmit.vue?vue&type=script&lang=js"
export * from "./ButtonSubmit.vue?vue&type=script&lang=js"

import "./ButtonSubmit.vue?vue&type=style&index=0&id=8d25ce88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d25ce88"]])

export default __exports__